import React from "react";
import { Button, Column, Columns, Modal, Section } from "@allxsmith/bestax-bulma";
import ContactSection from "../Contact/ContactSection";





export default function ContactModal({job, dataFresh, open, setOpen, handleSave, triggerChange, endpoint}){




    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
          closeOnBlur
          active={open}
          onClose={() => {
            setOpen(false);
          }}
        >
            <Modal.Content>
                <Section style={{ backgroundColor: "white" }}>
                    <Columns isMultiline>
                      <Column>
                        <ContactSection
                          title="Customer 1"
                          contactUpdate={customer => triggerChange({customer})}
                          endpoint={endpoint + "contacts"}
                          contact={job.customer || {}}
                          type="CC"
                          disabled={false}
                        />
                      </Column>
                    </Columns>
                    <Columns isMultiline>
                      <Column>
                        <ContactSection
                          title="Customer 2"
                          contactUpdate={customer2 => triggerChange({customer2})}
                          endpoint={endpoint + "contacts"}
                          contact={job.customer2 || {}}
                          type="CC"
                          disabled={false}
                        />
                      </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={handleSave}
                                isFullWidth
                            >
                                Turn Into Quote
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => {
                                    setOpen(false);
                                }}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );




}